// Screen 10, Users & Access (SPEC §8 Screen 10, §15.2, §15.3; J-073). Admin only: any other role reads
// why the page is empty, and the API refuses either way. J-210: the screen is told who the caller is
// and whether they hold every ACO, so it can disable what the server would refuse and say why.
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { AlertBanner } from "@vbltc/ui/components/alert-banner/alert-banner";

import { UsersScreen } from "@/features/aco-admin/components/users-screen";
import { meAccessQueryOptions } from "@/features/auth/api/me-access";
import { usePermission } from "@/features/auth/use-permission";

export const Route = createFileRoute("/_authenticated/admin/users")({
  staticData: { screenName: "Users & Access" },
  component: UsersPage,
});

function UsersPage() {
  const canManage = usePermission({ acoAdmin: ["manageAccess"] });
  const { session } = Route.useRouteContext();
  const access = useQuery(meAccessQueryOptions());
  if (!canManage)
    return (
      <AlertBanner variant="info" title="Users & Access is for the admin role">
        An admin creates users and sets their access.
      </AlertBanner>
    );
  return <UsersScreen caller={{ id: session.user.id, allAcos: access.data?.allAcos === true }} />;
}
